const projects = [
  {
    id:8,
    title:"TrailerDB",
    image:"https://camo.githubusercontent.com/7d3fedd3dc1945c454dadbc5dd1be80960102697/68747470733a2f2f7265732e636c6f7564696e6172792e636f6d2f6368697261676a61696e2f696d6167652f75706c6f61642f76313539373333383434342f66726565736e697070696e67746f6f6c2e636f6d5f636170747572655f32303230303831333232333432385f7269777872692e706e67",
    githuburl:"https://github.com/mechiragjain/TrailerDB",
    linkedinurl:"https://trailerdb.netlify.app"
  },
  {
    id:10,
    title:'Github User Stats',
    image: "https://res.cloudinary.com/chiragjain/image/upload/v1618728999/github_users_yyxypm.png",
    githuburl:"https://github.com/mechiragjain/github-user-stats",
    linkedinurl:"https://githubuserstats.netlify.app/"
  },
  {
    id:1,
    title:"Instagram Clone",
    image:"https://res.cloudinary.com/chiragjain/image/upload/v1590089759/freesnippingtool.com_capture_20200522010500_zggf8k.png",
    githuburl:"https://github.com/mechiragjain/Instagram-Clone",
    linkedinurl:"https://www.linkedin.com/posts/mechiragjain_100daysofcode-instagram-react-activity-6667274977072549888-Lvr5"
  },
  {
    id:7,
    title:"ChatGram",
    image:"https://res.cloudinary.com/chiragjain/image/upload/v1592832252/freesnippingtool.com_capture_20200622175903_clslzv.png",
    githuburl:"https://github.com/mechiragjain/Chat-Application",
    linkedinurl:"https://chatgramapp.netlify.app"
  },
  {
    id:9,
    title:"Image Compressor",
    image:"https://github.com/mechiragjain/Image-Compressor/raw/master/src/Images/Project.png",
    githuburl:"https://github.com/mechiragjain/Image-Compressor",
    linkedinurl:"https://imagecompressor.netlify.app/"
  },
  {
    id:2,
    title:"IDEE Interiors (Wordpress)",
    image:"https://res.cloudinary.com/chiragjain/image/upload/v1590094277/freesnippingtool.com_capture_20200522022058_wmqpsc.png",
    githuburl:"https://github.com/mechiragjain",
    linkedinurl:"http://ideeinteriors.com/"
  },
  {
    id:3,
    title:"Keeper App",
    image:"https://github.com/mechiragjain/Keeper-App/raw/master/images/keeperappimage.png",
    githuburl:"https://github.com/mechiragjain/Keeper-App",
    linkedinurl:"https://www.linkedin.com/posts/mechiragjain_webdevelopment-react-nodejs-activity-6651690232406208513-ZU4E"
  },
  {
    id:4,
    title:"App Landing Page",
    image:"https://res.cloudinary.com/chiragjain/image/upload/v1590913847/freesnippingtool.com_capture_20200531140025_ppzlvk.png",
    githuburl:"https://github.com/mechiragjain/tindog",
    linkedinurl:"https://mechiragjain.github.io/tindog/"
  },
  {
    id:5,
    title:"Drum Kit",
    image:"https://res.cloudinary.com/chiragjain/image/upload/v1590944778/freesnippingtool.com_capture_20200531223405_dbugwu.png",
    githuburl:"https://github.com/mechiragjain/Drum-Kit",
    linkedinurl:"https://mechiragjain.github.io/Drum-Kit/"
  },
  {
    id:6,
    title:"To Do List",
    image:"https://res.cloudinary.com/chiragjain/image/upload/v1590945057/freesnippingtool.com_capture_20200531224020_ttqofw.png",
    githuburl:"https://github.com/mechiragjain/To-Do-List",
    linkedinurl:"https://github.com/mechiragjain/To-Do-List"
  }
];

export default projects;
